import { BrowserRouter,Routes,Route } from 'react-router-dom';
//import './App.css';
// import Header from './Component/Header';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import Herosection from './Component/Herosection';
// import "boxicons/css/boxicons.min.css";
// import WhyChooseUs from './Component/Whychooseus';
// import Course from './Component/Course';
// import FAQ from './Component/FAQ';
// import Testimonials from './Component/Testimonials';
// import About from './Component/About';
// import Footer from './Component/Footer';
// import Placed from './Component/Placed';
// import FAQ from './Component/FAQ';

import Index from './Pages/Index';
import Aboutpage from './Pages/Aboutpage';
import ContactPage from './Pages/ContactPage';
import CoursePage from './Pages/CoursePage';
import BlogPage from './Pages/BlogPage';
// import CoursesSubPage from './Pages/CoursesSubPage';
import CourseDetails from './Pages/CourseDetails';
import SubCoursePage from './Pages/SubCoursePage.jsx';
import MainCoursePage from './Pages/MainCoursePage.jsx';
import InternalBlogPage from './Pages/InternalBlogPage.jsx';
function App() {
  return (
   <BrowserRouter>
    <Routes>
      <Route path="/" element={<Index/>}/>
      <Route path="Aboutpage" element={<Aboutpage/>}/>
      <Route path="ContactPage" element={<ContactPage/>}/>
<Route path="CoursePage" element={<CoursePage/>}/>
<Route path="BlogPage" element={<BlogPage/>}/>
<Route path="CourseDetails" element={<CourseDetails/>}/>
<Route path="SubCoursePage" element={<SubCoursePage/>}/>
<Route path="MainCoursePage" element={<MainCoursePage/>}/>
<Route path="InternalBlogPage" element={<InternalBlogPage/>}/>
</Routes>
   </BrowserRouter>
  );
}

export default App;
